import { getCityName } from 'utils/';

// const KEYCLOAK_DOMAIN = "http://13.229.133.162:8080/auth/";
const KEYCLOAK_DOMAIN = "http://beta.talkingstreet.in/auth/";

const home = () => {
  let cityName = getCityName();
  if (cityName)
    return `/${encodeURIComponent(cityName)}`;
  else
    return "/";
};
const cityHome = (cityName) => {
  return `/${encodeURIComponent(cityName)}`;
}
const citySelect = cityName => {
  return `/selectCity`;
};
const experiences = cityName => {
  return `/experiences/${encodeURIComponent(cityName)}`;
};

const eatery = (cityName, eateryLink) => {
  return `/eatery/${encodeURIComponent(cityName)}/${encodeURIComponent(
    eateryLink
  )}`;
};
const eateryEdit = (cityName, eateryLink) => {
  return `/eatery/${encodeURIComponent(
    eateryLink
  )}/edit`;
};
const story = storyLink => {
  return `/story/${getCityName()}/${encodeURIComponent(storyLink)}`;
};
const urlSaved = storyLink => {
  return `${(storyLink)}`;
};

const storyEditMode = storyLink => {
  return `/story/${encodeURIComponent(storyLink)}/edit`;
};
const storyWithCity = (cityName, storyLink) => {
  return `/story/${encodeURIComponent(cityName)}/${encodeURIComponent(
    storyLink
  )}`;
};
const eateryLanding = cityName => {
  return `/eateries/${encodeURIComponent(cityName)}`;
};
const aboutTalkingstreet = () => {
  return `/about-us`;
};

const ourLiveExperienceCities = cityName => {
  return `https://talkingstreet.in/experiences/${cityName}`;
};
const contributorProfileLinks = id => {
  return `/contributor/${id}`;
};
const contributorSubDraftsLink = () => {
  return `/my-dashboard/drafts`;
};

const contributorPublishedArticle = () => {   // Need to Change
  return `/my-dashboard/published`;
};

const map = (lat, lng) => {
  return `https://www.google.com/maps/place/${lat},${lng}`;
};

const staticLink = staticLink => {
  return `/${staticLink}`;
};

const searchLink = keyword => {
  return `/search?key=${encodeURIComponent(keyword)}`;
};

const listiclesViewLinks = listName => {
  return `/listicle/${getCityName()}/${encodeURIComponent(listName)}`;
};
const listicleWithCity = (cityName, linkTitle) => {
  return `/listicle/${encodeURIComponent(cityName)}/${encodeURIComponent(linkTitle)}`;
};
const listiclesAddEditLinks = id => {
  return `/listicle/${id}/edit`;
};

const loginLink = () => {
  return `/login?redirect=${window.location.pathname}`;
};

const logoutLink = () => {
  return `${KEYCLOAK_DOMAIN}realms/spring-boot-application/protocol/openid-connect/logout?redirect_uri=${window
    .location.origin + window.location.pathname}`;
};

const contributorDashboardLink = () =>
  `/my-dashboard`;

const addEatery = () => `/eatery/add`;
const addStory = () => `/story/add`;
const addListicle = () => `/listicle/add`;

export default {
  home,
  cityHome,
  eatery,
  map,
  citySelect,
  staticLink,
  experiences,
  loginLink,
  logoutLink,
  urlSaved,
  eateryLanding,
  story,
  searchLink,
  aboutTalkingstreet,
  ourLiveExperienceCities,
  contributorProfileLinks,
  storyWithCity,
  eateryEdit,
  storyEditMode,
  contributorSubDraftsLink,
  contributorDashboardLink,
  contributorPublishedArticle,
  listiclesViewLinks,
  listiclesAddEditLinks,
  addEatery,
  addStory,
  addListicle,
  listicleWithCity
};
